import { mountVeivoDocuments } from "@veivo/web-sdk";
import { useRef } from "react";
import { Button, Spinner } from "@/components/atoms";
import { ContactSupport } from "../ContactSupport";
import { useVeivoPanel, VeivoSession } from "../useVeivoPanel";

/**
 * Step 1 (DEV-1902): Veivo's documents panel. Each document is checked as it
 * arrives — what it must show, whether it matches the plate from Find — and
 * the walk-around opens only once every required one is accepted (Gate 1).
 */
export const DocumentsStep = ({
  session,
  accepted,
  support = null,
  onDocumentsValid,
  onContinue,
  onFinishLater,
  saving,
}: {
  session: VeivoSession | null;
  /** Every required document accepted, as the server says. */
  accepted: boolean;
  /** A document isn't valid, or the validation was refused: support can
   *  check it and let the operator continue (DEV-2002). */
  support?: "documents" | "rejected" | null;
  onDocumentsValid: () => void;
  onContinue: () => void;
  onFinishLater: () => void;
  saving: boolean;
}) => {
  const host = useRef<HTMLDivElement>(null);
  useVeivoPanel(host, mountVeivoDocuments, session, { onDocumentsValid });

  return (
    <div className="flex flex-col gap-6">
      <div ref={host} data-testid="veivo-documents" />
      {support === "documents" && (
        <ContactSupport lead="Can't get a document accepted?" tail="they can check it and let you continue." />
      )}
      {support === "rejected" && (
        <ContactSupport emphasis lead="This vehicle couldn't be verified." tail="they can check it and let you continue." />
      )}
      <div className="flex flex-col-reverse gap-3 xl:flex-row xl:justify-end">
        <Button variant="secondary" size="lg" className="w-full xl:w-auto" disabled={saving} onClick={onFinishLater}>
          {saving ? <Spinner /> : "Save and finish later"}
        </Button>
        <Button variant="primary" size="lg" className="w-full xl:w-auto" disabled={!accepted} onClick={onContinue}>
          Continue to walk-around
        </Button>
      </div>
    </div>
  );
};
